import React from "react";
import "./Footer.css";

/* --------- Inline SVG contact icons --------- */
const Icon = ({ name }) => {
  switch (name) {
    case "location":
      return (
        <svg viewBox="0 0 24 24" className="ft-contact__icon" aria-hidden="true">
          <path
            fill="currentColor"
            d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z"
          />
        </svg>
      );
    case "phone":
      return (
        <svg viewBox="0 0 24 24" className="ft-contact__icon" aria-hidden="true">
          <path
            fill="currentColor"
            d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
          />
        </svg>
      );
    case "email":
      return (
        <svg viewBox="0 0 24 24" className="ft-contact__icon" aria-hidden="true">
          <path
            fill="currentColor"
            d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
          />
        </svg>
      );
    default:
      return null;
  }
};

export default function Footer() {
  return (
    <footer className="ft">
      <div className="ft__container">
        {/* Main footer content */}
        <div className="ft-main">
          {/* Column 1 */}
          <div className="ft-col">
            <div className="ft-col-inner">
              <h3 className="ft-h">Quick Links</h3>
              <ul className="ft-list">
                <li><a href="/">Home</a></li>
               
                <li><a href="/spaces/lofts">Lofts</a></li>
                <li><a href="/spaces/commercial">Commercial</a></li>
                <li><a href="/commercial-tenants">Commercial Tenants</a></li>
              </ul>
            </div>
          </div>

          {/* Column 2 */}
          <div className="ft-col">
            <div className="ft-col-inner">
              <h3 className="ft-h">Support</h3>
              <ul className="ft-list">
                <li><a href="/contact">Contact</a></li>
                <li><a href="/Terms&conditions">Terms &amp; Conditions</a></li>
                <li><a href="/privacy-policy">Privacy Policy</a></li>
              </ul>
            </div>
          </div>

          {/* Column 3: Contact Information */}
          <div className="ft-col ft-col-contact">
            <div className="ft-col-inner">
              <h3 className="ft-h">Contact Us</h3>

              <div className="ft-contact">
                <div className="ft-contact__item">
                  <span className="ft-contact__icon-wrapper">
                    <Icon name="location" />
                  </span>
                  <div className="ft-contact__details">
                    <p className="ft-contact__label">Address</p>
                    <p className="ft-contact__text">
                      1944 Pacific Ave., Suite 210<br />
                      Tacoma, Washington 98402
                    </p>
                  </div>
                </div>

                <div className="ft-contact__item">
                  <span className="ft-contact__icon-wrapper">
                    <Icon name="phone" />
                  </span>
                  <div className="ft-contact__details">
                    <p className="ft-contact__label">Phone</p>
                    <p className="ft-contact__text">253-627-2663</p>
                  </div>
                </div>

                <div className="ft-contact__item">
                  <span className="ft-contact__icon-wrapper">
                    <Icon name="email" />
                  </span>
                  <div className="ft-contact__details">
                    <p className="ft-contact__label">Email</p>
                    <p className="ft-contact__text">info@harmon.property</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer bottom */}
        <div className="ft-bottom">
          <div className="ft-bottom__container">
            <div className="ft-bottom-content">
              <p>
                © {new Date().getFullYear()} The Harmon Property. All rights reserved.{" "}
                <span aria-hidden="true">|</span>{" "}
                <a href="https://connectrader.com/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "none" }}>
                  Site By connectrader
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
